export { default } from "./TranslateAction";
